module.exports = __webpack_public_path__ + "Flag-533.e7b425d15532dec4eab9f252c72e734e.svg";